module.exports = __webpack_public_path__ + "img/Info-figure-1.548c6cef.png";